export const SignInUrls = {
  CUSTOMER_PORTAL_SIGN_IN: '/login',
  SIGN_UP_LEAD: '/sign-up/lead-customer',
  SIGN_UP_CUSTOMER: '/sign-up/customer',
  TEYASEER_SIGN_IN:
    'https://portal.teyaseer.ae/customers/s/login/?language=en_US&ec=302&startURL=%2Fcustomers%2Fs%2F',
  VENDOR_REGISTRATION: {
    ar: 'https://teyaseer.my.site.com/vendor/s/vendor-pre-qualification?language=ar',
    en: 'https://teyaseer.my.site.com/vendor/s/vendor-pre-qualification?language=en_US',
  },
  VENDOR_LOGIN: {
    ar: 'https://teyaseer.my.site.com/vendor/s/login/?language=ar',
    en: 'https://teyaseer.my.site.com/vendor/s/login/?language=en_US',
  },
};
